import * as API from 'services/ErplyAPI/api';
import {
  TYPE_SELECTPOS,
  TYPE_SET_LOADING,
  TYPE_SET_POSLIST,
  UPDATE_CURRENT_POS,
} from 'constants/PointsOfSale';
import { getPointsOfSale, getSelectedPos } from 'reducers/PointsOfSale';
import { checkIsDayOpen } from 'actions/OpenCloseDay';
import { getAllWarehouses } from 'reducers/warehouses';
import {
  REDUX_POSID,
  REDUX_WAREHOUSE,
  REDUX_WAREHOUSEID,
} from 'constants/persistence';

import { getClientCode } from '../reducers/Login';

import { addError } from './Error';

export const setPoslist = pointsOfSale => ({
  type: TYPE_SET_POSLIST,
  payload: pointsOfSale,
});

export const selectPos = id => async (dispatch, getState) => {
  if (id === null) {
    localStorage.removeItem(REDUX_POSID);
  } else {
    localStorage.setItem(REDUX_POSID, JSON.stringify(id));
  }
  const pos = getPointsOfSale(getState()).find(pos => pos.pointOfSaleID === id);
  if (pos) {
    localStorage.setItem(
      REDUX_WAREHOUSEID,
      JSON.stringify(`${pos.warehouseID}`),
    );
    const warehouseFound =
      getAllWarehouses(getState()).find(
        warehouse => warehouse.warehouseID === pos.warehouseID,
      ) || null;
    if (warehouseFound) {
      localStorage.setItem(REDUX_WAREHOUSE, JSON.stringify(warehouseFound));
    }
  }

  dispatch({ type: TYPE_SELECTPOS, payload: id });
  if (pos) {
    dispatch(checkIsDayOpen({ pointOfSaleID: id }));
  }
};

export const setLoading = loading => ({
  type: TYPE_SET_LOADING,
  payload: loading,
});

export function loadPointsOfSale() {
  return async dispatch => {
    try {
      dispatch(setLoading(true));
      const pointsOfSale = await API.getPointsOfSale();
      dispatch(setPoslist(pointsOfSale));
      return pointsOfSale;
    } catch (e) {
      dispatch(addError(e.message));
    } finally {
      dispatch(setLoading(false));
    }
    return null;
  };
}

export const updateCurrentPointOfSale = () => async (dispatch, getState) => {
  const { pointOfSaleID } = getSelectedPos(getState());
  try {
    const [pointOfSale] = await API.getPointsOfSale({ pointOfSaleID });
    dispatch({ type: UPDATE_CURRENT_POS, payload: pointOfSale });
    return pointOfSale;
  } catch (err) {
    console.error(`Failed to load current POS (id=${pointOfSaleID}`, err);
    return false;
  }
};
